import React from 'react';
import JobCategoryPicker from '../../JobCategoryPicker';
import DateTimePicker from '../../DateTimePicker';

const BasicInfoSection = ({
  formData,
  updateFormField,
  isEditing,
  jobLinked = false
}) => {
  return (
    <div className="bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden">
      <div className="bg-gray-50 px-6 py-4 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-pest-blue">Basic Information</h3>
      </div>

      <div className="p-6 space-y-4">
        <JobCategoryPicker
          selectedCategoryId={formData.job_category_id || ''}
          onCategorySelect={(categoryId, categoryPath) => {
            updateFormField('job_category_id', categoryId);
            updateFormField('category_path', categoryPath);
          }}
          disabled={jobLinked}
        />

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Service Date
          </label>
          <DateTimePicker
            value={formData.service_date}
            onChange={(val) => updateFormField('service_date', val)}
            dateOnly
            className="w-full"
          />
        </div>
      </div>
    </div>
  );
};

export default BasicInfoSection;
